import Abnormal from '@/pages/dashboard/components/Abnormal';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

import React, { useContext, useMemo } from 'react';
import './ActiveDegreeContentCo.scss'

interface IProps {
  className?: string
  style?: any
  w?: number,
  children: any
  props: any
}


const ActiveDegreeContentCo = (colProps: IProps) => {
  const { className = '', style, children, ...resetProps } = colProps || {};
  const contextObj = useContext(FilterContext)
  const { filterVal = { timeType: ['Week']}, filterLoading } = contextObj || {};
  const { timeType } = filterVal;

  const showChildren = useMemo(() => {
    return children?.filter((item:any) => {
      return item?.props?.config?.data?.timeTypeIsShowCom?.includes(timeType?.toLowerCase())
    }) || []
  }, [children])

  return (
    <>
      <Abnormal
        loadClassName='dbd-active-degerre-content-co-loading'
        isLoading={filterLoading}
        isError={false}
        isNoData={false}
        component={<div className={className} style={style}>
        {React.Children.map(showChildren, (child: any) => {
          return React.cloneElement(
            child,
            { ...resetProps }
          );
        })}
      </div>}
      />
    </>

  );
};

export default ActiveDegreeContentCo;
